// A short three-note chime for new orders and bookings, made with the Web
// Audio API (no sound file). Browsers only allow sound after the user has
// clicked or typed on the page, so unlockSound() runs on the first interaction.
const KEY = 'posq_order_sound'
let ctx = null

function audio() {
  if (ctx) return ctx
  const AudioCtx = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext)
  if (!AudioCtx) return null
  try { ctx = new AudioCtx() } catch { ctx = null }
  return ctx
}

export function unlockSound() {
  const c = audio()
  if (c && c.state === 'suspended') c.resume().catch(() => {})
}

export function soundEnabled() {
  try { return localStorage.getItem(KEY) !== 'off' } catch { return true }
}

export function setSoundEnabled(on) {
  try { localStorage.setItem(KEY, on ? 'on' : 'off') } catch { /* storage unavailable */ }
}

export function playOrderSound({ force = false } = {}) {
  if (!force && !soundEnabled()) return
  const c = audio()
  if (!c) return
  if (c.state === 'suspended') c.resume().catch(() => {})
  const start = c.currentTime + 0.02
  // Played twice so it is heard over a busy room.
  for (const offset of [0, 0.9]) {
    ;[[880, 0], [1175, 0.16], [1568, 0.32]].forEach(([freq, at]) => {
      const osc = c.createOscillator()
      const gain = c.createGain()
      const t0 = start + offset + at
      osc.type = 'sine'
      osc.frequency.value = freq
      gain.gain.setValueAtTime(0.0001, t0)
      gain.gain.exponentialRampToValueAtTime(0.4, t0 + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.4)
      osc.connect(gain).connect(c.destination)
      osc.start(t0)
      osc.stop(t0 + 0.45)
    })
  }
}
